import { createSagaMiddleware } from 'core/middlewares/utilities';

import { rootEffects } from './root-effects';

export const middleware = createSagaMiddleware();

/**
 * Initialize the effects middleware
 *
 */
export function init() {
  middleware.run(rootEffects);
}
